<template>
  <rich-button @click="commands.paragraph" v-bind:isActive="isActive.paragraph()" v-bind:icon="'paragraph'" />
</template>

<script>
  import ParagraphButton from './ParagraphButton.ts'
  export default ParagraphButton
</script>
